import { gql } from '@apollo/client';

export const PUSH_BLUETOOTH_LOG = gql`
  mutation PushBluetoothLog($input: PushBluetoothLogInput!) {
    pushBluetoothLog(input: $input) {
      boolean
    }
  }
`;
